import z from "zod";

import { TransactionSchema } from "../shared/transaction-schema";

export const PurchaseAcknowledgedSchema = z.object({
	action: z.literal("purchase"),
	requestId: z.string().optional(),
	data: z.object({
		sessionUuid: z.string(),
		state: z.literal("ACKNOWLEDGED"),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type PurchaseAcknowledged = z.infer<typeof PurchaseAcknowledgedSchema>;

export const PurchaseTerminalBusySchema = z.object({
	action: z.literal("purchase"),
	data: z.object({
		sessionUuid: z.string(),
		status: z.literal("TERMINAL_BUSY"),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type PurchaseTerminalBusy = z.infer<typeof PurchaseTerminalBusySchema>;

export const PurchaseResponseSchema = z.object({
	action: z.literal("purchase"),
	requestId: z.string().optional(),
	data: z
		.object({
			status: z.union([
				z.literal("APPROVED"),
				z.literal("DECLINED"),
				z.literal("FAILED"),
			]),
		})
		.merge(TransactionSchema),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type PurchaseResponse = z.infer<typeof PurchaseResponseSchema>;

export const PurchaseSignatureVerificationSchema = z.object({
	action: z.literal("signatureVerification"),
	requestId: z.string().optional(),
	data: z.object({
		sessionUuid: z.string(),
		signature: z.string().optional(),
		state: z.union([
			z.literal("AWAITING_SIGNATURE"),
			z.literal("SIGNATURE_CLEARED"),
			z.literal("SIGNATURE_SUBMITTED"),
		]),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type PurchaseSignatureVerification = z.infer<
	typeof PurchaseSignatureVerificationSchema
>;

export const PurchaseTransactionEventSchema = z.object({
	action: z.literal("transactionEvent"),
	data: z.object({
		displayMessage: z.string().optional(),
		event: z.union([
			z.literal("AWAITING_ACCOUNT_SELECTION"),
			z.literal("AWAITING_APPLICATION_SELECTION"),
			z.literal("AWAITING_PAYMENT_METHOD"),
			z.literal("AWAITING_PIN_ENTRY"),
			z.literal("AWAITING_TIP_ENTRY"),
			z.literal("DISPLAYING_PAYMENT_MESSAGE"),
			z.literal("PROCESSING"),
			z.literal("RETRYING_PAYMENT_METHOD"),
			z.literal("TIP_PROVIDED"),
		]),
		sessionUuid: z.string(),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type PurchaseTransactionEvent = z.infer<
	typeof PurchaseTransactionEventSchema
>;
